import { useSortBy, UseSortByProps } from 'react-instantsearch';

export const useSearchSortBy = ({ items }: UseSortByProps) => {
  const { options, refine, currentRefinement } = useSortBy({
    items,
  });

  const handleChange = (event: any) => {
    refine(event.target.value);
  };

  return {
    options,
    value: currentRefinement,
    handleChange,
  };
};
